export const context = {
  select: {
    placeholder: "Choisir une organisation",
  },
  toaster: {
    contextUpdated: "L'organisation a été mise à jour",
  },
};
